import React from "react";
import LeaveManager from "../../components/attendance/LeaveManager";

export default function StaffLeavePage() {
  return <LeaveManager subjectType="STAFF" title="Staff Leave Entry" />;
}
